import * as Yup from "yup";
import { REGULAR_EXPRESSION } from "../../constants/regular-expressions";
import moment from "moment";
import { distributorsubscriptionPlanDomainsSchema } from "./ValidationSchema";

export const baseSubscriptionSchema = Yup.object().shape({
  ...distributorsubscriptionPlanDomainsSchema,
  effectiveFromDate: Yup.date().when(
    "contentSubscriptionId",
    (contentSubscriptionId, schema) => {
      if (contentSubscriptionId > 0) {
        return schema
          .nullable()
          .default(null)
          .required("")
          .typeError("Please input the date in the correct format");
      }
      return schema
        .nullable()
        .default(null)
        .required("")
        .min(
          moment(new Date().setHours(0, 0, 0, 0)),
          "Date must be a present or future date"
        )
        .typeError("Please input the date in the correct format");
    }
  ),
  effectiveToDate: Yup.date().when(
    ["contentSubscriptionId", "savedEffectiveToDate", "effectiveFromDate"],
    (
      contentSubscriptionId,
      savedEffectiveToDate,
      effectiveFromDate,
      schema
    ) => {
      const isExistingSubscription = contentSubscriptionId > 0;
      const allowEdit = !isExistingSubscription && !savedEffectiveToDate;
      if (allowEdit) {
        if (effectiveFromDate && !isExistingSubscription) {
          return schema
            .nullable()
            .default(null)
            .min(
              Yup.ref("effectiveFromDate"),
              "Date must be greater than or equal to the Effective From date."
            )
            .typeError("Please input the date in the correct format");
        }
        return schema
          .nullable()
          .default(null)
          .min(
            moment(new Date().setHours(0, 0, 0, 0)),
            "Date must be a present or future date"
          )
          .typeError("Please input the date in the correct format");
      }
      return schema
        .nullable()
        .default(null)
        .typeError("Please input the date in the correct format");
    }
  ),
});

export const ContentSchema = Yup.object().shape({
  typeOfContent: Yup.string().required("Please Select"),
  name: Yup.string().required("").min(2, "Too Short!").max(150, "Too Long!"),
  latestVersion: Yup.string()
    .required("")
    .min(1, "Too Short!")
    .max(25, "Too Long!"),
  webLink: Yup.string().when("typeOfContent", (typeOfContent, schema) => {
    if (typeOfContent === "11") {
      return schema
        .required("")
        .matches(REGULAR_EXPRESSION.URL, "Incorrect Format");
    }
    return schema
      .matches(REGULAR_EXPRESSION.URL, "Incorrect Format")
      .nullable(true);
  }),
  formNumber: Yup.string().when("typeOfContent", (typeOfContent, schema) => {
    if (["1", "2"].includes(typeOfContent)) {
      return schema.required("").nullable().max(150, "Too Long!");
    }
    return schema.nullable().max(150, "Too Long!");
  }),
  subscriptions: Yup.array().of(baseSubscriptionSchema),
  marketingDescription: Yup.string().when(
    "previewType",
    (previewType, schema) => {
      if (previewType === "3") {
        return schema.required("");
      }
      return schema.nullable(true);
    }
  ),
});
